/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Nav_LearnInputs */

const en_gc_home_nav_learn = /** @type {(inputs: Gc_Home_Nav_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn`)
};

const zh_gc_home_nav_learn = /** @type {(inputs: Gc_Home_Nav_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用教程`)
};

/**
* | output |
* | --- |
* | "Learn" |
*
* @param {Gc_Home_Nav_LearnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_nav_learn = /** @type {((inputs?: Gc_Home_Nav_LearnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Nav_LearnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_nav_learn(inputs)
	return zh_gc_home_nav_learn(inputs)
});
export { gc_home_nav_learn as "gc.home.nav.learn" }